import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.08685 14.0164L15.3967 7.70657L14.4108 6.68779L9.08685 12.0117L6.5892 9.51408L5.60329 10.5L9.08685 14.0164ZM5.53756 5.57042C6.91784 4.19014 8.57199 3.5 10.5 3.5C12.428 3.5 14.0712 4.19014 15.4296 5.57042C16.8099 6.9288 17.5 8.57199 17.5 10.5C17.5 12.428 16.8099 14.0822 15.4296 15.4624C14.0712 16.8208 12.428 17.5 10.5 17.5C8.57199 17.5 6.91784 16.8208 5.53756 15.4624C4.17919 14.0822 3.5 12.428 3.5 10.5C3.5 8.57199 4.17919 6.9288 5.53756 5.57042Z" fill="currentColor" />
  </svg>
);
